import React from "react";
import {Link} from "react-router-dom";

export default function StepNavigation({next, back, save, save_next}: { next?: string, back?: string, save?: ()=>void, save_next?: ()=>void }) {
    return <div className="custom-mt-40">
        {save_next && <button className="button green ozon_save_next" onClick={save_next}>Сохранить и перейти далее  <i className="fa fa-arrow-right" aria-hidden="true"/></button>}
        {save && <button className="button green ozon_save" onClick={save}>Сохранить</button>}
        {next && <Link className="button" to={next} >
            Далее <i className="fa fa-arrow-right" aria-hidden="true"/>
        </Link>}
        {back && <span>
            {next && "или"}
        <Link to={back}> вернуться назад</Link>
        </span>}

    </div>
}